var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  buildTripleExpression: () => buildTripleExpression,
  isTripleExpression: () => isTripleExpression
});
var import_mathFunctionError = __toModule(require("../../../../error/mathFunctionError"));
const TRIPLE_FUNCTIONS = [
  "calculateGravamen",
  "calculateGravamenRound",
  "calculateGravamenRoundInteger"
];
const isTripleExpression = (functionName) => {
  return TRIPLE_FUNCTIONS.includes(functionName);
};
const buildTripleExpression = (functionName, operands1, operands2) => {
  if (!isTripleExpression(functionName)) {
    throw new import_mathFunctionError.MathFunctionError(`Function ${functionName}. Not a triple function`);
  }
  const [firstOperand, secondOperand] = operands1;
  const [thirdOperand] = operands2;
  if (firstOperand === void 0 || secondOperand === void 0 || thirdOperand === void 0) {
    const message = `Invalid operands for ${functionName}: 1=${firstOperand}, 2=${secondOperand}, 3=${thirdOperand}`;
    throw new import_mathFunctionError.MathFunctionError(message);
  }
  return `${functionName}(${firstOperand}, ${secondOperand}, ${thirdOperand})`;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  buildTripleExpression,
  isTripleExpression
});
